import React from 'react';

const FourZeroFour = () => (
  <div className="four-zero-four">
    <div>
      <h1>Dangit!</h1>
      <p>That’s a 404 for&nbsp;sure</p>
    </div>
  </div>
);

export default FourZeroFour;



// WEBPACK FOOTER //
// ./src/components/FourZeroFour.js